import Select from 'react-select';
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Label,
  Input,
  FormGroup,
} from 'reactstrap';

import { useSelector } from 'react-redux';
import styles from 'pages/Promotions/styles/promo.module.css';
import { useTranslation } from 'react-i18next';
import { RootState } from 'slices';
import { PromoFormValues } from 'types/promotion/promotionTypes';
import { FormikProps } from 'formik';
import { CustomReactSelectStyles } from 'pages/Promotions/styles/customStyles';
import { InputActionMeta, SelectOptions } from 'types/common/FormTypes';
import { useMemo, useRef, useState } from 'react';
import { CheckboxOption } from 'Components/pos2u/CustomReactSelectComponents/CustomReactSelectOption';
import { transformOptionsToListsArray } from 'utils/common/handleSelect';
import { Dispatch } from 'redux';
import { setselectMultiBranches } from 'slices/promotions/reducer';
import { FREE_GIFT_ALLOWED_STORE_IDS, PromoTypes } from 'pages/Promotions/PromoConstant';
import { UserInfo } from 'types/info/user';
import PopoverWithCloseButton from './PopoverWithCloseButton';
import CustomReactSelect from 'Components/pos2u/CustomReactSelect';
import { CustomBranchMenu } from 'Components/pos2u/CustomReactSelectComponents/CustomReactSelectBranchMenu';
import { MultiSelectSingleLineStyles } from 'styles/common/multiSelectSingleLineStyle';
interface SelectedData {
  value: string;
  label: string;
}

const PromoInfo = ({
  formik,
  dispatch,
}: {
  formik: FormikProps<PromoFormValues>;
  dispatch: Dispatch;
}) => {
  const { t } = useTranslation();
  const layoutState = useSelector((state: RootState) => state.Layout);
  const promotionsState = useSelector((state: RootState) => state.Promotions);
  const infoUser = useSelector((state: RootState) => state.Info.user) as UserInfo;
  const showFreeGift = FREE_GIFT_ALLOWED_STORE_IDS.includes(infoUser?.store_id_login);

  const { layoutModeType } = layoutState;
  const { isEdit, showAllValidateErrors, BranchOptions, selectMultiBranches } =
    promotionsState;

  const selectBranchRef = useRef(null);

  const isDarkMode = layoutModeType === 'dark';

  const [inputValue, setInputValue] = useState('');

  const handleInputChange = (newValue: string, meta: InputActionMeta) => {
    if (meta.action === 'input-change') {
      setInputValue(newValue);
    }
  };

  const handleChangeBranch = (selectedOptions: SelectedData[]) => {
    dispatch(setselectMultiBranches(selectedOptions));
    formik
      .setFieldValue(`branch`, transformOptionsToListsArray(selectedOptions))
      .then(() => formik.setFieldTouched(`branch`, true));
  };

  const promotionType = useMemo(
    () => formik.values?.promoType || '0',
    [formik.values.promoType]
  );

  const isMobile = window.innerWidth <= 768;
  const mobileStylesPopover: React.CSSProperties = isMobile
    ? {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }
    : {};

  return (
    <Card>
      <CardHeader>
        <h5 className="card-title mb-0">{t('Promo_Info')}</h5>
      </CardHeader>
      <CardBody className={`${styles['card-body-pd']}`}>
        <Row>
          <Col lg={6}>
            <div className="mb-3 row">
              <Label htmlFor="promoName" className="col-sm-3 col-form-label">
                {t('promoName')} <span style={{ color: 'red' }}>*</span>
              </Label>
              <Col sm={9}>
                <div className="mt-2">
                  <Input
                    type="text"
                    className="form-control"
                    id="promoName"
                    name="promoName"
                    value={formik.values.promoName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    required
                  />

                  {(formik.touched.promoName &&
                    formik.errors.promoName &&
                    typeof formik.errors.promoName === 'string') ||
                  (formik.isValid === false &&
                    formik.errors.promoName &&
                    showAllValidateErrors === true) ? (
                    <div className="text-danger mt-1">
                      {formik.errors.promoName}
                    </div>
                  ) : null}
                </div>
              </Col>
            </div>

            <div className=" row">
              <Label htmlFor="branch" className="col-sm-3 col-form-label">
                {t('Branch')} <span style={{ color: 'red' }}>*</span>
              </Label>
              <Col sm={9}>
                <div className="mt-2">
                  <FormGroup key={1}>
                    <CustomReactSelect
                      ref={selectBranchRef}
                      id="branch"
                      name="branch"
                      aria-label="branch"
                      value={selectMultiBranches}
                      defaultValue={selectMultiBranches}
                      isMulti={true}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      inputValue={inputValue}
                      onInputChange={handleInputChange}
                      onChange={handleChangeBranch}
                      onBlur={() => {
                        formik.setFieldTouched('branch', true);
                        (document.activeElement as HTMLElement)?.blur();
                      }}
                      options={BranchOptions}
                      components={{
                        Menu: CustomBranchMenu,
                        Option: CheckboxOption,
                      }}
                      styles={MultiSelectSingleLineStyles(isDarkMode)}
                      placeholder={t('ProductPage_PleaseSelect')}
                    />
                    {(formik.touched.branch &&
                      formik.errors.branch &&
                      typeof formik.errors.branch === 'string') ||
                    (formik.isValid === false &&
                      formik.errors.branch &&
                      showAllValidateErrors === true) ? (
                      <div className="text-danger mt-1">
                        {formik.errors.branch}
                      </div>
                    ) : null}
                  </FormGroup>
                </div>
              </Col>
            </div>
          </Col>
          <Col lg={6}></Col>
        </Row>
        <Row>
          <Col xs={10} lg={6}>
            <div className="row">
              <Label htmlFor="promoType" className="col-sm-3 col-form-label">
                {t('promoType')} <span style={{ color: 'red' }}>*</span>
              </Label>
              <Col sm={9}>
                <div className="mt-2">
                  <FormGroup key={2}>
                    <Select
                      isDisabled={isEdit}
                      styles={CustomReactSelectStyles(isDarkMode)}
                      id="promoType"
                      name="promoType"
                      aria-label="promoType"
                      data-testid="promoType_test"
                      options={PromoTypes(t, showFreeGift)}
                      value={
                        formik.values.promoType
                          ? PromoTypes(t, showFreeGift)
                              .flatMap((group: SelectOptions) => group.options)
                              .find(
                                (option: { value: string }) =>
                                  option.value === formik.values.promoType
                              )
                          : null
                      }
                      onChange={(option: { value: string }) => {
                        formik
                          .setFieldValue('promoType', option?.value)
                          .then(() =>
                            formik.setFieldTouched('promoType', true)
                          );
                        if (option && ['1', '2', '3'].includes(option.value)) {
                          formik
                            .setFieldValue('promoFreeGift.freeList', [])
                            .then(() =>
                              formik.setFieldTouched(
                                'promoFreeGift.freeList',
                                true
                              )
                            );
                        }
                        formik
                          .setFieldValue('promoDiscount', [
                            {
                              qty: '',
                              discount: '',
                            },
                          ])
                          .then(() =>
                            formik.setFieldTouched('promoDiscount', true)
                          );
                      }}
                      onBlur={() => {
                        formik.setFieldTouched('promoType', true);
                      }}
                      placeholder={t('ProductPage_PleaseSelect')}
                    />

                    {(formik.touched.promoType &&
                      formik.errors.promoType &&
                      typeof formik.errors.promoType === 'string') ||
                    (formik.isValid === false &&
                      formik.errors.promoType &&
                      showAllValidateErrors === true) ? (
                      <div className="text-danger mt-1">
                        {formik.errors.promoType}
                      </div>
                    ) : null}
                  </FormGroup>
                </div>
              </Col>
            </div>
          </Col>
          <Col xs={2} lg={6} style={mobileStylesPopover}>
            <div
              className={`mt-3 ${
                formik.values.promoType !== '' ? '' : 'd-none'
              }`}
            >
              {' '}
              <PopoverWithCloseButton promoType={promotionType} />
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};
export default PromoInfo;
